/* en-GB locale */
export default {
  chat: {
    newConversation: {
      fromDID: 'From DDI'
    }
  },
  videoconf: {
    tooltip: {
      minimize: 'Minimise',
      license:
        'Total conference(s): {total}, Licence: {license}, Allowed on the system: {global}'
    }
  },
  settings: {
    dids: {
      title: 'DDI',
      table: {
        noData: 'No DDI available for this user'
      }
    },
    screenPop: {
      variable: {
        did: 'DDI'
      }
    }
  },
  help: {
    notifications: {
      enable: 'Enable or disable notifications which includes incoming call notifications and incoming message notifications. If this setting is enabled and you allowed notifications in your browser, then you will get system wide notifications allowing you to get notified even when the call panel is minimised. If this setting is enabled but browser notifications is not, you will have notifications inside call panel only.'
    },
    followme: {
      num: 'Add number to ring. May be local extension or external DDI.'
    },
    toggle:
      'Toggle destination has 2 destinations, you can switch from one to another ' +
      'by dialling "*44*ID" (you can find ID in this grid) or from this page by clicking ' +
      'destination. You can use it as a destination from your favourite feature (digital ' +
      'receiptionists, destination aliases, time conditions ...).'
  },
  vmail: {
    forceTranscriptionEnableDialog: {
      text: 'Your message will not be summarised or transcribed',
      buttons: {
        enable: 'Enable',
        later: 'Later',
        never: 'Never'
      }
    },
    tip: {
      addToFavorites: 'Add to favourites',
      removeFromFavorites: 'Remove from favourites'
    },
    btn: {
      favourite: 'Mark as favourite',
      unfavorite: 'Unmark as favourite',
      addToFavorites: 'Add to favourites',
      removeFromFavorites: 'Remove from favourites'
    },
    cfg: {
      settings: {
        summarise: 'Enable summary',
        categorise: 'Enable category'
      }
    }
  }
}
